import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-no-data-message',
    templateUrl: './no-data-message.component.html',
    styleUrls: ['./no-data-message.component.scss'],
    standalone: false
})
export class NoDataMessageComponent {
  @Input() icon: string = 'pi-exclamation-triangle';
  @Input() iconColor: string = 'text-yellow-500';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() showBackground: boolean = true;
  @Input() containerClasses: string = '';

  getContainerClasses(): string {
    let classes = 'no-data-container';
    
    if (this.showBackground) {
      classes += ' with-background';
    }
    
    if (this.containerClasses) {
      classes += ' ' + this.containerClasses;
    }
    
    return classes;
  }

  getIconClasses(): string {
    let classes = 'pi no-data-icon ' + this.icon;
    
    if (this.iconColor) {
      classes += ' ' + this.iconColor;
    }
    
    return classes;
  }
}
